import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  TABLE_CELL_HOVER_BG_COLOR,
  TABLE_HEADER_BG_COLOR,
  TABLE_SCROLL_SHADOW_COLOR,
} from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';

interface ProductClassesStylesProps {
  tableWidth: number;
  maxProductsAmountInProductLine: number;
}

const styles: ComponentStylesProps<ProductClassesStylesProps> = {
  tableWrapper: {
    overflow: 'hidden',
    borderRadius: '10px',
    border: `2px solid ${colors.neutral[300]}`,
    margin: '3rem 0 8rem',
  },
  table: ({ tableWidth }) => ({
    width: `max(100%, ${tableWidth}rem)`,
  }),

  productCell: ({ maxProductsAmountInProductLine }) => ({
    padding: 0,
    verticalAlign: 'top',
    '& label': {
      padding: '2rem',
      borderBottom: maxProductsAmountInProductLine > 1 && `0.1rem solid ${colors.neutral[300]}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  }),
  wideCell: {
    padding: '2rem',
  },
  tableCell: {
    border: `0.05rem solid ${colors.neutral[400]}`,
    '&:last-child': {
      borderRightWidth: 0,
    },
    '&:first-child': {
      borderLeftWidth: 0,
      // ee class name
      width: '5rem',
      wordBreak: 'break-word',
    },
  },
  tableRow: {
    '&:last-child td': {
      borderBottomWidth: 0,
    },
  },
  tableHeading: {
    backgroundColor: `${TABLE_HEADER_BG_COLOR}`,
    padding: '2rem',
    '&:not(:last-child)': {
      borderRight: `0.05rem solid ${colors.neutral[400]}`,
    },
    '&:first-child': {
      // ee class name
      width: '5rem',
      textAlign: 'center',
    },
  },

  productLineIdTitle: {
    margin: 0,
    '& svg': {
      width: '2.2rem',
    },
    justifyContent: 'center',
    '& span': {
      fontSize: '1.4rem',
    },
  },
  eeClass: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& svg': {
      marginRight: '1rem',
    },
  },
  // Due to the table library’s built-in logic that increases the cell `z-index`,
  // the built-in sticky behavior is broken.
  // These styles are a temporary custom workaround to handle it.
  stickyHeader: {
    zIndex: 4,
  },
  leftSticky: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: '-12px',
      width: '12px',
      height: '100%',
      pointerEvents: 'none',
      opacity: 0,
      transition: 'opacity 150ms ease',
      background: `linear-gradient(to right, ${TABLE_SCROLL_SHADOW_COLOR}, rgba(0, 0, 0, 0))`,
    },
    '[data-can-scroll-left] &': {
      '&::after': {
        opacity: 1,
      },
    },
  },
  classCell: {
    backgroundColor: colors.neutral.white,
    'tr:hover &': {
      backgroundColor: TABLE_CELL_HOVER_BG_COLOR,
    },
  },
  typeClassName: {
    left: '2.4rem',
    width: 'fit-content',
    maxWidth: '100%',
  },
  typeRowCategoryCell: {
    backgroundColor: colors.neutral[800],
    color: colors.neutral.white,
    fontWeight: 700,

    '& svg': {
      fill: colors.neutral.white,
    },
  },
  typeRow: {
    '&:hover > td': {
      backgroundColor: colors.neutral[800],
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
